export const APP_CONFIG = {
  NAME: 'DairyTranslate',
  DESCRIPTION: 'AI Assistant for Translation and Code Conversion',
  FREE_USAGE_LIMIT: 2,
  MAX_INPUT_LENGTH: 250,
  MAX_HISTORY_ITEMS: 20
} as const;

export const API_ENDPOINTS = {
  ASK_AI: '/askAI',
  HEALTH: '/health',
  CREATE_PAYMENT_INTENT: '/create-payment-intent',
  CREATE_SUBSCRIPTION: '/create-subscription'
} as const;

export const STORAGE_KEYS = {
  USAGE_COUNT: 'usageCount',
  USER_HISTORY: 'userHistory',
  USER_PREFERENCES: 'userPreferences'
} as const;
